<div class="container-fluid">
    <div  id="search-bar" class="row">
        <div class="col-lg-10 offset-lg-2">
            <span class="banner-title">The Filparty Explorer</span>
            <div class="d-flex">
                <div class="col-md-9">
                    <div class="search"><form [formGroup]="searchForm" (ngSubmit)="onSubmit()"><fa-icon [icon]="faSearch" class="fa fa-search"></fa-icon> <input type="text" formControlName="rechercher" [ngClass]="{ 'is-invalid': submitted && f['rechercher'].errors }" class="form-control" placeholder="Search by Tx Hash / Address / Block"> <button class="btn btn-primary">Search</button></form> </div>
                </div>
            </div>
        </div> 
    </div>
    <div id="kpi" class="row" *ngIf="btcTickets">
        <div class="col-lg-2 col-md-2 col-sm-12 offset-lg-1">
            <div class="d-flex box-kpi">
                <div class="card-block">
                    <div class="card-item">
                        <span class="icon">
                            <img src="assets/images/verified.png" alt="" srcset="">
                        </span>
                        <div class="textarea">
                            <span class="title">Network Id</span>
                            <span class="value">{{ btcTickets.chain_id | number:'.0-2':'fr-FR' }}</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-lg-2 col-md-2 col-sm-12">
            <div class="d-flex box-kpi">
                <div class="card-block">
                    <div class="card-item">
                        <span class="icon">
                            <img src="assets/images/back-in-time.png" alt="" srcset="">
                        </span>
                        <div class="textarea">
                            <span class="title">Average block time</span>
                            <span class="value">{{ btcTickets.avg_block_time }} seconds</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-lg-2 col-md-2 col-sm-12">
            <div class="d-flex box-kpi">
                <div class="card-block">
                    <div class="card-item">
                        <span class="icon">
                            <img src="assets/images/blockchain.png" alt="" srcset="">
                        </span>
                        <div class="textarea">
                            <span class="title">Total blocks</span>
                            <span class="value">{{ btcTickets.block_number | number:'.0-2':'fr-FR'}}</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-lg-2 col-md-2 col-sm-12">
            <div class="d-flex box-kpi">
                <div class="card-block">
                    <div class="card-item">
                        <span class="icon">
                            <img src="assets/images/man.png" alt="" srcset="">
                        </span>
                        <div class="textarea">
                            <span class="title">Known accounts</span>
                            <span class="value">{{ btcTickets.nmbr_accounts | number:'.0-2':'fr-FR' }}</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-lg-2 col-md-2 col-sm-12">
            <div class="d-flex box-kpi">
                <div class="card-block">
                    <div class="card-item">
                        <span class="icon">
                            <img src="assets/images/price-tag.png" alt="" srcset="">
                        </span>
                        <div class="textarea">
                            <span class="title">Gas price</span>
                            <span class="value">{{ btcTickets.gas_price/1000000000 | number:'1.2-5' }} GWEI</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- <div class="col-lg-4 offset-lg-4">
            <div class="d-flex box-kpi">
                <div class="card-block">
                    <div class="card-item">
                        <span class="icon">
                            <img src="assets/images/prices-btc.svg" alt="" srcset="">
                        </span>
                        <div class="textarea">
                            <span class="title">Bitcoin BTC</span>
                            <span class="value">{{ btcTickets[1].last_trade_price }}&nbsp;&nbsp;&nbsp;&nbsp;<span [ngClass]="{'success': btcTickets[1].evol > 0, 'error': btcTickets[1].evol < 0 }"> {{ btcTickets[1].evol }} %</span></span>
                        </div>
                    </div>
                    <hr>
                    <div class="card-item">
                        <span class="icon">
                            <img src="assets/images/prices-eth.svg" alt="" srcset="">
                        </span>
                        <div class="textarea">
                            <span class="title">Ethereum ETH</span>
                            <span class="value">{{ btcTickets[0].last_trade_price }}&nbsp;&nbsp;&nbsp;&nbsp;<span [ngClass]="{'success': btcTickets[0].evol > 0, 'error': btcTickets[0].evol < 0 }"> {{ btcTickets[0].evol }} %</span></span>
                        </div>
                    </div>
                </div>
                <div class="card-block">
                    <div #textarea class="card-item">
                        <div class="textarea">
                            
                        </div>
                    </div>
                    <hr>
                    <div class="card-item">
                        <div class="textarea">
                            
                        </div>
                    </div>
                </div>
            </div>
        </div> -->
    </div>
</div>

<div class="container-fluid">
    <div class="row mb-5" *ngIf="isHome">
        <div class="col-lg-6 mb-4 mb-lg-0">
            <div class="card h-100">
                <div class="card-header">
                    <h2 class="card-header-title">Lastest Filparty Blocks</h2>
                </div>
                <div class="card-body">
                    <table class="table table-striped table-hover">
                        <thead>
                          <tr>
                            <th scope="col">From</th>
                            <th scope="col">Tx#</th>
                            <th scope="col">Difficulty</th>
                            <th scope="col">Total Difficulty</th>
                            <th scope="col">Time</th>
                          </tr>
                        </thead>
                        <tbody>
                            <tr *ngFor="let item of homeBlocks; let i = index">
                                <th scope="row">{{ item.number }}</th>
                                <ng-template [ngIf]="item.transactions.length == 0" [ngIfElse]="noBlocks">
                                    <td>{{ item.transactions.length }}</td>
                                </ng-template>
                                <ng-template #noBlocks>
                                    <td><span class="block-link" (click)="openBlock(item.number, item.transactions.length)">{{ item.transactions.length }}</span></td>
                                </ng-template>
                                <td>{{ item.difficulty }}</td>
                                <td>{{ item.totalDifficulty }}</td>
                                <td>{{ item.timestamp*1000 | date :'yyyy-MM-dd HH:mm:ss' }}</td>
                            </tr>
                        </tbody>
                    </table>
                    <!-- <div class="card-footer">
                        <a href="">View all transactions</a>
                    </div> -->
                </div>
            </div>
        </div>
        
        <div class="col-lg-6 mb-4 mb-lg-0">
            <div class="card h-100">
                <div class="card-header">
                    <h2 class="card-header-title">Cryptocurrency Prices</h2>
                </div>
                <div class="card-body">
                    <table class="table table-striped table-hover">
                        <thead>
                          <tr>
                            <th scope="col">Name</th>
                            <th scope="col">Price</th>
                            <th scope="col">Market Cap</th>
                            <th scope="col">Change (24hr)</th>
                          </tr>
                        </thead>
                        <tbody>
                            <tr *ngFor="let item of btcTicketsAll; let i = index">
                                <th scope="row" style="width: 35%; white-space: nowrap; overflow: hidden; text-align:justify"><img src="https://cryptocompare.com{{item.CoinInfo.ImageUrl}}"  alt="" class="img-fluid" style="width:10%"> {{ item.CoinInfo.FullName }}</th>
                                <td>{{ item.DISPLAY.USD.PRICE }}</td>
                                <td>{{ item.DISPLAY.USD.MKTCAP }}</td>
                                <td style="font-weight: bold" [ngClass]="{'success': item.DISPLAY.USD.CHANGEPCTHOUR > 0, 'error': item.DISPLAY.USD.CHANGEPCTHOUR < 0 }">{{ item.DISPLAY.USD.CHANGEPCTHOUR }} %</td>
                            </tr>
                        </tbody>
                    </table>
                    <div class="card-footer">
                        <span (click)="viewTransaction($event)">View all transactions</span>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="row mb-5" *ngIf="isSearch">
        <div class="col-lg-8 offset-lg-2 mb-4 mb-lg-0">
            <div class="card h-100">
                <div class="card-header">
                    <h2 class="card-header-title">Transactions of {{ recherche }}</h2>
                </div>
                <div class="card-body">
                    <table class="table table-striped table-hover">
                        <thead>
                          <tr>
                            <th scope="col">From</th>
                            <th scope="col">Tx#</th>
                            <th scope="col">Difficulty</th>
                            <th scope="col">Total Difficulty</th>
                            <th scope="col">Time</th>
                          </tr>
                        </thead>
                        <tbody>
                            <tr *ngFor="let item of homeBlocks; let i = index">
                                <th scope="row">{{ item.number }}</th>
                                <ng-template [ngIf]="item.transactions.length == 0" [ngIfElse]="noBlocks">
                                    <td>{{ item.transactions.length }}</td>
                                </ng-template>
                                <ng-template #noBlocks>
                                    <td><span class="block-link" (click)="openBlock(item.number, item.transactions.length)">{{ item.transactions.length }}</span></td>
                                </ng-template>
                                <td>{{ item.difficulty }}</td>
                                <td>{{ item.totalDifficulty }}</td>
                                <td>{{ item.timestamp*1000 | date :'yyyy-MM-dd HH:mm:ss' }}</td>
                            </tr>
                        </tbody>
                    </table>
                    <div class="card-footer">
                        <span class="block-link" (click)="homepage()">Return to homepage</span>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="row hashresult" *ngIf="isHashSearch">
        <ng-container *ngIf="homeHash">
            <ng-container *ngIf="homeHash.length == 1">
                <div class="col-lg-5 offset-lg-4">
                    <div class="d-flex box-hashresult">
                        <div class="card-block">
                            <div class="card-item">
                                <div class="textarea">
                                    <span class="title">{{ title }}</span>
                                    <span class="value">{{ recherche }}</span>
                                </div>
                            </div>
                            <hr>
                            <div class="card-item">
                                <div class="textarea">
                                    <span class="title">From</span>
                                    <span class="value">{{ homeHash[0].from }}</span>
                                </div>
                            </div>
                            <hr>
                            <div class="card-item">
                                <div class="textarea">
                                    <span class="title">To</span>
                                    <span class="value">{{ homeHash[0].to }}</span>
                                </div>
                            </div>
                            <hr>
                            <div class="card-item">
                                <div class="textarea">
                                    <span class="title">Value</span>
                                    <span class="value">{{ homeHash[0].value }} flp</span>
                                </div>
                            </div>
                            <hr>
                            <div class="card-item">
                                <div class="textarea">
                                    <span class="title">Txn Fee</span>
                                    <span class="value">{{ homeHash[0].txfee | number }} flp</span>
                                </div>
                            </div>
                            <hr>
                            <div class="card-item">
                                <div class="textarea">
                                    <span class="title">Nonce</span>
                                    <span class="value">{{ homeHash[0].nonce }}</span>
                                </div>
                            </div>
                            <div class="card-footer">
                                <span class="block-link" (click)="homepage()">Return to homepage</span>
                            </div>
                        </div>
                    </div>
                </div>
            </ng-container>
            <ng-container  *ngIf="homeHash.length > 1">
                <div class="col-lg-4">
                    <div class="d-flex box-hashresult">
                        <div class="card-block">
                            <ng-container *ngFor="let item of homeHash; let index">
                                <div class="card-item">
                                    <div class="textarea">
                                        <span class="title">{{ title }}</span>
                                        <span class="value">{{ recherche }}</span>
                                    </div>
                                </div>
                                <hr>
                                <div class="card-item">
                                    <div class="textarea">
                                        <span class="title">From</span>
                                        <span class="value">{{ item.from }}</span>
                                    </div>
                                </div>
                                <hr>
                                <div class="card-item">
                                    <div class="textarea">
                                        <span class="title">To</span>
                                        <span class="value">{{ item.to }}</span>
                                    </div>
                                </div>
                                <hr>
                                <div class="card-item">
                                    <div class="textarea">
                                        <span class="title">Value</span>
                                        <span class="value">{{ item.value }} flp</span>
                                    </div>
                                </div>
                                <hr>
                                <div class="card-item">
                                    <div class="textarea">
                                        <span class="title">Txn Fee</span>
                                        <span class="value">{{ item.txfee | number }} flp</span>
                                    </div>
                                </div>
                                <hr>
                                <div class="card-item">
                                    <div class="textarea">
                                        <span class="title">Nonce</span>
                                        <span class="value">{{ item.nonce }}</span>
                                    </div>
                                </div>
                            </ng-container>
                            <div class="card-footer">
                                <span class="block-link" (click)="homepage()">Return to homepage</span>
                            </div>
                        </div>
                    </div>
                </div>
            </ng-container>
        </ng-container>
    </div>

    <div class="row hashresult" *ngIf="isAddress">
        <div class="col-lg-7 offset-lg-3">
            <div class="d-flex box-hashresult" *ngIf="homeAddress">
                <div class="card-block">
                    <div class="card-item">
                        <div class="textarea">
                            <span class="title">Address</span>
                            <span class="value">{{ homeAddress.address }}</span>
                        </div>
                    </div>
                    <hr>
                    <div class="card-item">
                        <div class="textarea">
                            <span class="title">Balance</span>
                            <span class="value">{{ homeAddress.balance }} flp</span>
                        </div>
                    </div>
                    <div class="card-footer">
                        <span class="block-link" (click)="homepage()">Return to homepage</span>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <app-donate *ngIf="isDonation"></app-donate>
    <app-all-currencies *ngIf="isAllTransaction"></app-all-currencies>
</div>
